import * as React from 'react'
import { ListGroup, Jumbotron } from 'react-bootstrap'

import { FaMinusCircle } from 'react-icons/fa'

export class PageNotFoundComponent extends React.Component<{}, {}> {
  render() {
    return (
      <Jumbotron>
        <h1 className="text-danger">
          <FaMinusCircle /> 404 Page not found
        </h1>
        <p>
          Oops! That page does not exist.
        </p>
        <p>
          If you think this is incorrect, please try one of the following:
        </p>
        <ListGroup>
          <ListGroup.Item action href="/help">Contact the software team</ListGroup.Item>
          <ListGroup.Item action href="/">Otherwise, try returning to the home page</ListGroup.Item>
        </ListGroup>
      </Jumbotron>
    )
  }
}
